export enum PrimaryFeature {
  DASHBOARD = 'dashboard',
  REPORTING = 'reporting',
  INSIGHTS = 'insights',
  SHARED_DOCUMENTS = 'shared-documents',
  COLLABORATION = 'collaboration',
  API_KEY_GENERATOR = 'api-key-generator',
  LABS_AND_FORMULATIONS = 'labs-and-formulations',
  ACCOUNT = 'account',
  PORTAL_MEMBERS = 'portal-members',
  COOKIE_STATEMENT = 'cookie-statement',
  TERMS_OF_USE = 'terms-of-use',
  API_DOCUMENTATION = 'api-documentation',
  ADMIN_CENTER = 'admin-center',
}

export enum SecondaryFeature {
  DASHBOARD_KEY_SALES_NUMBERS = 'key-sales-numbers',

  REPORTING_SALES = 'sales',
  REPORTING_OPPORTUNITIES = 'opportunities',
  REPORTING_SUPPLY_CHAIN = 'supply-chain',
  REPORTING_INCIDENTS = 'incidents',
  REPORTING_PRODUCT_SAMPLES = 'product-samples',
  REPORTING_LEADS = 'leads',
  REPORTING_TARGETS = 'targets',

  INSIGHTS_MARKET_INSIGHTS = 'market-insights',
  INSIGHTS_EXPANSION_OPPORTUNITIES = 'expansion-opportunities',
  INSIGHTS_SOCIAL_LISTENING = 'social-listening',
  INSIGHTS_CUSTOMER_PORTAL_INSIGHTS = 'customer-portal-insights',
  INSIGHTS_PRODUCT_FEEDBACK = 'product-feedback',

  LABS_AND_FORMULATIONS_FORMULATIONS = 'formulations',

  SHARED_DOCUMENTS_LATEST_ACTIVITY = 'latest-activity',
  SHARED_DOCUMENTS_ALL_DOCUMENTS = 'all-documents',

  COLLABORATION_SHARED_DOCUMENTS = 'shared-documents',
  COLLABORATION_API_MANAGEMENT = 'api-management',
  COLLABORATION_EDI_INFORMATION = 'edi-information',

  PRINCIPAL_ADMINISTRATION = 'principal-administration',
  GLOBAL_USERS = 'global-users',
}

export enum TertiaryFeature {
  COLLABORATION_API_MANAGEMENT_KEY_HISTORY = 'key-history',
  COLLABORATION_API_MANAGEMENT_KEY_OVERVIEW = 'key-overview',
  INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_PRODUCT_VIEWS = 'product-views',
  INSIGHTS_CUSTOMER_PORTAL_INSIGHTS_MY_SUPPLIER_PAGE = 'my-supplier-page',
}

export type AnyFeature = PrimaryFeature | SecondaryFeature | TertiaryFeature;
